export default {
      id: "ic_fleche_scrolltop-usage",
      viewBox: "0 0 45 45",
      url: "../dist/images/" + "sprite.svg#ic_fleche_scrolltop-usage",
      toString: function () {
        return this.url;
      }
    }